import React from "react";

function TermsAndConditions() {
  return (
    <div id="terms" className="modal fade" role="dialog" aria-hidden="true">
      <div
        className="modal-dialog modal-xl modal-dialog-centered"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Terms of Use</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body p-4">
            <p className="lead">
              Quidam lisque persius interesset his et, in quot quidam
              persequeris vim, ad mea essent possim iriure. Lisque persius
              interesset his et, in quot quidam persequeris vim, ad mea essent
              possim iriure. lisque persius interesset his et, in quot quidam
              mea essent possim iriure.
            </p>
            <h3 className="mb-3 mt-4">Terms of Use</h3>
            <p>
              Lisque persius interesset his et, in quot quidam persequeris vim,
              ad mea essent possim iriure. Lisque persius interesset his et, in
              quot quidam persequeris vim, ad mea essent possim iriure. lisque
              persius interesset his et, in quot quidam mea essent possim
              iriure.
            </p>
            <h5 className="text-4">
              Part I – Information MXapp collects and controls
            </h5>
            <p>
              Persius interesset his et, in quot quidam persequeris vim, ad mea
              essent possim iriure. Lisque persius interesset his et, in quot
              quidam persequeris vim, ad mea essent possim iriure.
            </p>
            <h5 className="text-4">
              Part II – Information that MXapp processes on your behalf
            </h5>
            <p>
              Lisque persius interesset his et, in quot quidam persequeris vim,
              ad mea essent possim iriure. Lisque persius interesset his et, in
              quot quidam persequeris vim.
            </p>
            <h5 className="text-4">Part III – General</h5>
            <p>
              Interesset his et, in quot quidam persequeris vim, ad mea essent
              possim iriure. Lisque persius interesset his et, in quot quidam
              persequeris vim, ad mea essent possim iriure. lisque persius
              interesset his et, in quot quidam mea essent possim iriure.
            </p>
            <h3 className="mb-3 mt-4">Privacy Policy</h3>
            <p>
              Quidam lisque persius interesset his et, in quot quidam
              persequeris vim, ad mea essent possim iriure. Lisque persius
              interesset his et, in quot quidam persequeris vim, ad mea essent
              possim iriure. lisque persius interesset his et, in quot quidam
              mea essent possim iriure.
            </p>
            <ol className="lh-lg">
              <li>
                Lisque persius interesset his et, in quot quidam persequeris
                vim, ad mea essent possim iriure.
              </li>
              <li>
                Quidam lisque persius interesset his et, Lisque persius
                interesset his et, in quot quidam persequeris vim, ad mea essent
                possim iriure.
              </li>
              <li>
                In quot quidam persequeris vim, ad mea essent possim iriure.
                Quidam lisque persius interesset his et.
              </li>
              <li>
                Quidam lisque persius interesset his et, Lisque persius
                interesset his et.
              </li>
              <li>
                Interesset his et, Lisque persius interesset his et, in quot
                quidam persequeris vim, ad mea essent possim iriure.
              </li>
              <li>
                Persius interesset his et, Lisque persius interesset his et, in
                quot quidam persequeris vim, ad mea essent possim iriure.
              </li>
              <li>
                Quot quidam persequeris vim Quidam lisque persius interesset his
                et, Lisque persius interesset his et, in quot quidam persequeris
                vim, ad mea essent possim iriure.
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsAndConditions;
